import axios from 'axios'
import {jwtDecode} from 'jwt-decode'

import API from './API'
import {
    ADMIN_ROLE,
    FLORIST_FORGOT_PASSWORD,
    FLORIST_RESET_PASSWORD,
    FLORIST_RESET_PASSWORD_TOKEN,
    IMPERSONATE_SWITCH_USER,
    IMPERSONATE_TEST_USER,
    LOGIN_API,
    LOGIN_IMPERSONATE_API,
    SWITCH_SHOP_API,
} from '../constants/Constants'

/**
 * @param {{
 *           username: string,
 *           password: string,
 *           email: string
 *         }} credentials
 * @param {boolean} impersonate
 * @return {AxiosPromise<any>}
 */
async function authenticate(credentials, impersonate = false) {
  return API({
    method: 'post',
    url: impersonate ? LOGIN_IMPERSONATE_API : LOGIN_API,
    data: credentials,
  })
}

async function switchUser(codefl) {
    return API({
        method: 'get',
        url: IMPERSONATE_TEST_USER,
        data: {codefl},
    })
}

async function switchShop(codefl) {
  return API({
    method: 'post',
    url: SWITCH_SHOP_API,
    data: {codefl},
  })
}

/**
 *
 */
function logout(impersonate = false) {
  globalThis.localStorage.removeItem('authToken')
  delete axios.defaults.headers.Authorization
  sessionStorage.clear()

  if (impersonate) {
    window.location.reload()
  }
}

/**
 * @return {boolean}
 */
function isAuthenticated() {
  const token = globalThis.localStorage.getItem('authToken')

  if (token) {
    const {exp: expiration} = jwtDecode(token)

    if (expiration * 1000 > new Date().getTime()) {
      return true
    }
    return false
  }
  return false
}

/**
 * isAdministrator
 *
 * @param user
 * @return {boolean}
 */
function isAdministrator(user) {
  return Boolean(user.roles.find((item) => item === ADMIN_ROLE))
}

/**
 * @return {boolean|unknown}
 */
function getUser() {
  const token = globalThis.localStorage.getItem('authToken')

  if (token) {
    const {exp: expiration} = jwtDecode(token)
    if (expiration * 1000 > new Date().getTime()) {
      const user = jwtDecode(token)
      return user
    }
    return false
  }
  return false
}

/**
 * @param credentials
 * @returns {AxiosPromise}
 */
function forgotPassword(credentials) {
  return API({
    method: 'post',
    url: FLORIST_FORGOT_PASSWORD,
    data: credentials,
  })
}

/**
 * @param credentials
 * @returns {AxiosPromise}
 */
function resetPassword(credentials) {
  return API({
    method: 'post',
    url: FLORIST_RESET_PASSWORD,
    data: credentials,
  })
}

/**
 * @return {AxiosPromise}
 */
function resetPasswordToken() {
  return API({
    method: 'get',
    url: FLORIST_RESET_PASSWORD_TOKEN,
  })
}

function sendErrorLogin(error) {
  return API({
    method: 'get',
    url: '/florajet/error-login/send',
    data: error,
  })
}

function updatePassword(data, hash) {
    return API({
        method: 'POST',
        url: `/password/update?hash=${hash}`,
        data,
    });
}

export default {
    authenticate,
    switchUser,
    logout,
    switchShop,
    isAuthenticated,
    isAdministrator,
    getUser,
    forgotPassword,
    resetPassword,
    resetPasswordToken,
    sendErrorLogin,
    updatePassword,
}
